import PaymentsScreenConnector from './PaymentsScreenConnector';

export default PaymentsScreenConnector;
